import AddToCalendar, {
    Type,
} from "./lobby/details/actions/add-to-calendar/AddsToCalendar";
import { translate } from "@mediaspace/shared/utils";

interface AddToCalendarContainerProps {
    entryId: string;
    size?: "large" | "medium";
}

/**
 * wrapper for AddToCalendar component
 * for reuse in all hero components
 */
const AddToCalendarContainer = (props: AddToCalendarContainerProps) => {
    const { entryId, size } = props;

    return (
        <AddToCalendar
            items={[
                {
                    label: translate("Outlook"),
                    type: Type.OUTLOOK,
                },
                {
                    label: translate("Google"),
                    type: Type.GOOGLE,
                },
            ]}
            sessionId={entryId}
            textProps={{
                addToCalendarActionText: translate("Add To Calendar"),
                addToCalendarAddedText: "",
            }}
            collapseToIconBreakpoint={"xs"}
            translucent={true}
            size={size}
        />
    );
};

export default AddToCalendarContainer;
